export default class TransactionPath {
    constructor(data) {
        this.apps = data.apps;
        this.destination = data.destination;
        this.forwardingFeePretransaction = data.forwardingFeePretransaction;
        this.transactions = data.transactions;
    }
}
//# sourceMappingURL=TransactionPath.js.map